<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dialog-titlebar>{{ data?.title }}</dialog-titlebar>
<div mat-dialog-content class="ticket-edit-dialog-content">
	<ticket-edit-form
		[ticketForm]="this.editFormGroup"
		[editTicket$]="data.ticket$"
		[roleList$]="data.roleList$"
		[locationList$]="data.locationList$"
		[projectMembers$]="data.projectMembers$"
		[priorityList$]="data.priorityList$"
		[varianceList$]="data.varianceList$"
		[classOverrides]="this.ticketType"
		[calendarWorkdays]="data.calendarWorkdays"
		[activeLineDate$]="data.activeLineDate$"
	>
	</ticket-edit-form>
</div>
<button-footer
	(buttonSaveOrClose)="onSave()"
	[disabled]="(editFormGroup.statusChanges | async) === 'INVALID'"
	[saveOrCloseButtonText]="saveOrCloseButtonText | uppercase"
>
	<button
		*ngIf="!onDesktop"
		middleButton
		mat-button
		color="primary"
		(click)="onCancel()"
		automationId="mobileCancel"
	>
		{{ cancelButtonText | uppercase }}
	</button>
</button-footer>
